<template>
	<div>
		<input
			:type="type"
			v-model="context.model"
			:value="context.value"
			v-bind="context.attributes"
			@blur="context.blurHandler"
			disabled
		>
	</div>
</template>

<script>
import FormulateInputMixin from "@braid/vue-formulate/src/FormulateInputMixin";

export default {
    name: "ViewText",
    mixins: [FormulateInputMixin],
}
</script>

<style scoped>
input {
	border: none !important;
}
</style>